import cookie from 'js-cookie'
import GLOBAL_VARIABLE from '../../constants/global-variable.enum'

class PlatformSSO {
	constructor({ platform, session }) {
		this.type = 'sso'
		this.session = session
		this.ssoPlatform = platform || { type: 'SSO', getAuthorization: () => `SSO ${this.session}` }
	}

	getAuthorization() {
		const authStr = this.ssoPlatform.getAuthorization()
		return /undefined/.test(authStr) ? `SSO ${this.session}` : authStr
	}

	getWebTokenBody() {
		return {
			web_token: cookie.get(GLOBAL_VARIABLE.WEB_TOKEN_KEY),
			web_sso_session: cookie.get(GLOBAL_VARIABLE.WEB_SSO_SESSION_KEY)
		}
	}
	
	updateSession() {
		const value = cookie && cookie.get(GLOBAL_VARIABLE.WEB_SSO_SESSION_KEY)
		if (value) {
			this.session = value
		}
	}

	clear() {
		// 웹토큰은 PlatformSSO의 관리 키가 아니기 때문에 삭제하지 않는다.
		cookie.remove(GLOBAL_VARIABLE.WEB_SSO_SESSION_KEY, { domain: GLOBAL_VARIABLE.WEB_TOKEN_DOMAIN })
		this.ssoPlatform && this.ssoPlatform.clear()
	}

	/**
	 * SSO 값을 검증합니다.
	 * @returns {Boolean}
	 */
	isValidSession() {
		return !!(this.session && cookie.get(GLOBAL_VARIABLE.WEB_SSO_SESSION_KEY) && cookie.get(GLOBAL_VARIABLE.WEB_TOKEN_KEY))
	}
}

export default PlatformSSO